/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.Login";
        class LoginWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("LoginWidgetTypeClass.createInstance()");
                    return new LoginWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("LoginWidgetTypeClass._storeHtml()");
                    LoginWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("LoginWidgetTypeClass::constructor");
                this._allowedOnLogon = true;
                if (LoginWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/Login/login.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.LoginWidgetTypeClass = LoginWidgetTypeClass;
        class LoginWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loginContent = null;
                this._customLoginContent = null;
                this._loginLogo = null;
                this._loginHeading = null;
                this._loginIntro = null;
                this._loginButton = null;
                this._logonHandler = null;
                this._customConfig = null;
                this.presentInstance = () => {
                    this._log.info("LoginWidgetInstanceClass.presentInstance()");
                    let presentInstance = false;
                    let config = this._config;
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (!appConfig.hasOwnProperty('ShowHomepagePanel') || appConfig.ShowHomepagePanel) {
                        presentInstance = true;
                    }
                    if (!presentInstance) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("widget instance for '" + config.PlaceHolder + "' is not enabled");
                        }
                        return;
                    }
                    this._container.innerHTML = LoginWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    // get elements to hold
                    this._loginContent = this._container.querySelector('#loginContent');
                    this._customLoginContent = this._container.querySelector('#customLoginContent');
                    this._loginLogo = this._loginContent.querySelector('#loginLogo');
                    this._loginHeading = this._loginContent.querySelector('#loginTextHeading');
                    this._loginIntro = this._loginContent.querySelector('#loginTextIntro');
                    this._loginButton = this._loginContent.querySelector('#loginButton');
                    this._widgets.setTitle(this._config, this._container.querySelector('#loginHeading'), 'STR_WPT_LOGON');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    if (config.hasOwnProperty('CustomContent') && config.CustomContent) {
                        this._customConfig = config.CustomContent;
                        this._showCustomLoginContent();
                    }
                    else {
                        this._showLoginContent();
                    }
                    this._type.instanceReady(this.getHandle());
                };
                this._showLoginContent = () => {
                    this._log.info("LoginWidgetInstanceClass._showLoginContent()");
                    let config = this._config;
                    let content = null;
                    if (config.hasOwnProperty('Content') && config.Content) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using content from widget config");
                        }
                        content = config.Content;
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using content from application config");
                        }
                        content = {};
                        let appConfig = this._core.Config.getApplicationConfig();
                        if (appConfig.hasOwnProperty('Images') && appConfig.Images.hasOwnProperty('LogonPageLogo')) {
                            content.LogoImg = appConfig.Images.LogonPageLogo;
                        }
                        if (appConfig.hasOwnProperty('Content') && appConfig.Content) {
                            if (appConfig.Content.hasOwnProperty('Heading') && appConfig.Content.Heading) {
                                content.Heading = appConfig.Content.Heading;
                            }
                            if (appConfig.Content.hasOwnProperty('Intro') && appConfig.Content.Intro) {
                                content.Intro = appConfig.Content.Intro;
                            }
                        }
                    }
                    let logonLogoSrc = null;
                    if (content.hasOwnProperty('LogoImg') && content.LogoImg) {
                        logonLogoSrc = content.LogoImg;
                    }
                    if (logonLogoSrc != null) {
                        this._loginLogo.src = logonLogoSrc;
                        this._core.Functions.showElement(this._loginLogo);
                    }
                    else {
                        this._core.Functions.hideElement(this._loginLogo);
                    }
                    // Translations
                    let buttonLabel = 'STR_WPT_LOGON';
                    if (content.hasOwnProperty('ButtonLabel') && content.ButtonLabel) {
                        buttonLabel = content.ButtonLabel;
                    }
                    this._core.Helper.setElementTranslation(this._loginButton.querySelector('#loginButtonLabel'), buttonLabel);
                    if (content.hasOwnProperty('Heading') && content.Heading) {
                        this._core.Helper.setElementTranslation(this._loginHeading, content.Heading);
                    }
                    if (content.hasOwnProperty('Intro') && content.Intro) {
                        this._core.Helper.setElementTranslation(this._loginIntro, content.Intro);
                    }
                    // Event Listener
                    this._loginButton.addEventListener('click', this._core.Navigation.Logon.presentLogonModal);
                    this._core.Functions.hideElement(this._customLoginContent);
                    this._core.Functions.showElement(this._loginContent);
                };
                this._showCustomLoginContent = () => {
                    this._log.info("LoginWidgetInstanceClass._showCustomLoginContent()");
                    let customContent = this._getCustomContentFromConfig();
                    if (customContent !== undefined) {
                        this._logonHandler = new Widgets.ComponentLogonHandler(this._core, this._customLoginContent, this, this._core.Navigation.Logon.presentLogonModal);
                        this._logonHandler.present();
                        this._core.Loader.getUnversionedHTML(customContent, this._finishCustomLoginContent, this._core.Helper.missingHtmlErrorCallback);
                        this._core.Functions.hideElement(this._loginContent);
                        this._core.Functions.showElement(this._customLoginContent);
                    }
                };
                this._getCustomContentFromConfig = () => {
                    this._log.info("LoginWidgetInstanceClass._getCustomContentFromConfig()");
                    let localCode = this._core.Locale.getSelectedLocale().LocaleCode;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking for custom content for locale: " + localCode);
                    }
                    let customContent = this._customConfig[localCode];
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got custom content: " + customContent);
                    }
                    if (customContent === undefined) {
                        customContent = this._customConfig.Default;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using default custom content: " + customContent);
                        }
                    }
                    return customContent;
                };
                this._finishCustomLoginContent = (htmlData) => {
                    this._log.info("LoginWidgetInstanceClass._finishCustomLoginContent()");
                    this._logonHandler.showLogonPage(htmlData);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("LoginWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
        }
        LoginWidgetInstanceClass.HtmlData = null;
        Widgets.LoginWidgetInstanceClass = LoginWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
